export let mayUppercase = "LCqLXc";
export default {mayUppercase};